import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface ModuleTile {
  to: string;
  label: string;
  icon: string;
  color: string;
}

const MODULES: ModuleTile[] = [
  { to: '/modules/rental',      label: 'Rental',       icon: 'fa-key',           color: 'var(--mod-rent)' },
  { to: '/modules/jobs',        label: 'Jobs',         icon: 'fa-wrench',        color: 'var(--mod-job)' },
  { to: '/modules/package',     label: 'Packages',     icon: 'fa-gift',          color: 'var(--mod-package)' },
  { to: '/modules/appointment', label: 'Appointments', icon: 'fa-calendar',      color: 'var(--mod-schedule)' },
  { to: '/modules/tradein',     label: 'Trade-In',     icon: 'fa-exchange',      color: 'var(--mod-tradein)' },
  { to: '/modules/service',     label: 'Service',      icon: 'fa-cogs',          color: 'var(--mod-service)' },
  { to: '/modules/voucher',     label: 'Vouchers',     icon: 'fa-ticket',        color: 'var(--mod-voucher)' },
];

export { MODULES };

export default function ModuleTiles() {
  const { t } = useTranslation();

  return (
    <div className="module-tiles">
      {MODULES.map((mod) => (
        <NavLink
          key={mod.to}
          to={mod.to}
          className={({ isActive }) =>
            `module-tile${isActive ? ' module-tile--active' : ''}`
          }
          style={{ '--tile-color': mod.color } as React.CSSProperties}
        >
          <i className={`fa ${mod.icon} module-tile__icon`} />
          <span className="module-tile__label">{t(mod.label, mod.label)}</span>
        </NavLink>
      ))}
    </div>
  );
}
